import { Component } from "react";

export default class Refetch extends Component {
  componentDidUpdate = (prevProps) => {
    if (this.props.version !== prevProps.version) {
      console.log("refetching");
      window.setTimeout(() => this.props.refetch(), 200);
    }
  };
  render() {
    return null;
  }
}
